import React from "react";
import { Link } from "react-router-dom";
import LoanCalculator from "../../components/LoanCalculator";
import { aboutParagraph, aboutParagraphHidden } from "../content/text";
import Typewriter from 'typewriter-effect';

export const About = () => {
  return (
    <div className="about_us maxw-1350">
        <LoanCalculator />
          <div className="about_us_content">
            <div className="title_section mt-3">
              <p className="sub_title flex flex-center">
                {/* <span>
                  <BsFillGrid1X2Fill
                    className="mr10"
                    style={{ marginBottom: "-2px" }}
                  />
                </span> */}
                <span>About CreduMoney</span>
              </p>
              <h2 className="mt20">
                CreduMoney—Your Ideal Instant Personal Loan Partner
                
              </h2>
            </div>
            <div className="about_para">
              <p>
                {aboutParagraph}
                <span className="hide_content">
                  {aboutParagraphHidden}
                </span>
                <br/>
                <br/>
                <Link className="btn_sl" to="/about-CreduMoney">Discover More...</Link>
              </p>
            </div>
          </div>
        </div>
  )
}
